import React from 'react';
import ModalFrame from '../../dashboard/components/product_item_components/ModalFrame';
import { statusBadgeClassName } from '../../../types/OrderStatusTypes';
import '../../dashboard/Dashboard.css';
import './OrderFilterSelectModal.css';

function OrderFilterSelectModal({
  isOpen,
  title,
  options,
  selectedIds,
  multiple = false,
  resetIds = [],
  colorizeStatus = false,
  onApply,
  onClose,
}) {
  const [draftIds, setDraftIds] = React.useState(selectedIds);

  const selectedKey = (selectedIds || []).join(',');
  const optionCount = options.length;

  React.useEffect(() => {
    if (!isOpen) return;
    const next = selectedKey === '' ? [] : selectedKey.split(',').map(Number);
    setDraftIds(next);
  }, [isOpen, selectedKey]);

  if (!isOpen) return null;

  const allChosen = multiple && (draftIds.length === 0 || draftIds.length === optionCount);

  const handleSelect = (id) => {
    if (!multiple) {
      onApply?.([id]);
      onClose?.();
      return;
    }

    setDraftIds((prev) => {
      if (prev.length === 0 || prev.length === optionCount) {
        return [id];
      }
      const next = prev.includes(id)
        ? prev.filter((item) => item !== id)
        : [...prev, id];
      if (next.length === 0 || next.length === optionCount) {
        return [];
      }
      return next;
    });
  };

  const handleApply = () => {
    onApply?.(draftIds);
    onClose?.();
  };

  const handleReset = () => {
    setDraftIds(resetIds);
    onApply?.(resetIds);
    onClose?.();
  };

  return (
    <ModalFrame title={title} onClose={onClose}>
      <div className="main-page-modalList" role="listbox" aria-multiselectable={multiple || undefined}>
        {options.map(({ id, label }) => {
          const selected = multiple ? !allChosen && draftIds.includes(id) : draftIds.includes(id);
          return (
            <button
              key={id}
              type="button"
              role="option"
              aria-selected={selected}
              className={
                selected
                  ? 'main-page-modalItem main-page-modalItemSelected'
                  : 'main-page-modalItem'
              }
              onClick={() => handleSelect(id)}
            >
              <span className="order-filter-statusItemLabel">{label}</span>
              {colorizeStatus ? (
                <span
                  className={statusBadgeClassName('order-filter-statusDot', id)}
                  aria-hidden="true"
                />
              ) : null}
            </button>
          );
        })}
      </div>
      {multiple ? (
        <div className="order-filter-select-actions">
          <button
            type="button"
            className="main-page-editButton main-page-editButtonSecondary"
            onClick={handleReset}
          >
            Сбросить
          </button>
          <button
            type="button"
            className="main-page-editButton main-page-editButtonPrimary"
            onClick={handleApply}
          >
            Применить
          </button>
        </div>
      ) : null}
    </ModalFrame>
  );
}

export default OrderFilterSelectModal;
